// extracted by mini-css-extract-plugin
export default {"closeBtn":"ModalCloseButton_closeBtn__R7nmv","showOnMobile":"ModalCloseButton_showOnMobile__Y0ekn"};